"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgLogItem = void 0;
class MsgLogItem {
    constructor(init) {
        Object.assign(this, init);
    }
}
exports.MsgLogItem = MsgLogItem;
